var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { List } from 'immutable';
import "./scss/stackTrace.scss";
import { Icon } from "../../UI";

const conformValidations = (expand, validations) => {
  if (!expand || !validations) {
    return null;
  }

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    validations.reduce(
      (memo, v, i) =>
      memo.concat( /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsx("div", {}, i,
        v.get('message'), ": ", v.get('instancePath')
        )
      ),
      []
    )
    ));

};

class StackTrace extends Component {
  constructor(props) {
    super(props);
    this.state = { expand: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { expand } = this.state;
    this.setState({ expand: !expand });
  }

  render() {
    const { message, validations } = this.props;
    const { expand } = this.state;
    const formatedMessage = expand ? message : `${message.substr(0, 50)}...`;
    return /*#__PURE__*/(
      _jsx("div", { className: "stack-trace", onClick: this.toggle }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "sort" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, formatedMessage),
      conformValidations(expand, validations)
      ));

  }
}

StackTrace.defaultProps = {
  message: '',
  validations: null
};






export default StackTrace;